/**
 * Os escritórios que atendem o banco da sessão (E143.F2, GUS-140, ADR-0097) — as opções do
 * seletor da abertura pelo banco. Espelha `apps/api/types/abertura_do_banco.EscritorioVinculadoOut`.
 */
import type { AxiosInstance } from 'axios';

export interface EscritorioVinculadoData {
  id: string;
  nome: string;
}

export async function listarEscritoriosVinculados(
  client: AxiosInstance,
): Promise<EscritorioVinculadoData[]> {
  const { data } = await client.get<EscritorioVinculadoData[]>('/bancos/me/escritorios-vinculados');
  return data;
}
